var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.5,
    height: 16,
    viewBox: "0 0 3.5 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#888;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.75,42.5a1.826,1.826,0,0,1-1.25-.525A1.741,1.741,0,0,1,14,40.75a1.973,1.973,0,0,1,.5-1.25,1.757,1.757,0,0,1,1.25-.5,1.856,1.856,0,0,1,1.225.5,1.763,1.763,0,0,1-1.225,3Zm7.475-.525a1.767,1.767,0,0,0,.525-1.225,1.874,1.874,0,0,0-.525-1.25A1.741,1.741,0,0,0,22,39a1.92,1.92,0,0,0-1.25.5,1.757,1.757,0,0,0-.5,1.25,1.856,1.856,0,0,0,.5,1.225,1.721,1.721,0,0,0,2.475,0Zm6.25,0A1.767,1.767,0,0,0,30,40.75a1.874,1.874,0,0,0-.525-1.25A1.741,1.741,0,0,0,28.25,39a1.92,1.92,0,0,0-1.25.5,1.757,1.757,0,0,0-.5,1.25,1.856,1.856,0,0,0,.5,1.225,1.721,1.721,0,0,0,2.475,0Z",
    transform: "translate(42.5 -14) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.8c1981d381996ba9f70c8252543bba81.svg";
export { ForwardRef as ReactComponent };